import { mediaQueries } from '@eti/styles';

export const isDesktopViewport = () => window.matchMedia(`${mediaQueries.large.up}`).matches;
